export default function color_convert(color) {
    var matchColors = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/;
    var match = matchColors.exec(color);
    if (match !== null) {
        return "#" + componentToHex(match[1]) + componentToHex(match[2]) + componentToHex(match[3]);
    }
}

export function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
}

export function splitColorOpa(color) {
    if (color.length > 7) {
        const outcolor = color.slice(0, -2);
        const opa = ("0x" + color.slice(7)) / 255;
        return { color: outcolor, opacity: opa };
    }
    return {color:color, opacity: 1};

}

/**
 * The firmware opacity attribute that carries a colour attribute's alpha
 * channel: bg_color -> bg_opa, bg_color10 -> bg_opa10, outline_color ->
 * outline_opa. The Designer stores those colours as one hex8 value for the
 * picker; the exporter splits them apart again (see ObjectGroup.addSplitColors),
 * and this is the single place that knows how the two wire keys relate.
 *
 * Only properties declared `format: 'hex8'` in the schema can carry an alpha
 * channel at all, so in practice this is reached by bg_color and outline_color.
 * Anything that doesn't look like a colour key falls back to bg_opa, preserving
 * the historical behaviour.
 */
export function opaWireKey(colorWireKey) {
    const parts = /^(.*)_color(\d*)$/.exec(colorWireKey ?? '');
    if (parts) return `${parts[1]}_opa${parts[2]}`;
    const digits = String(colorWireKey ?? '').slice(-2).match(/\d{2}/);
    return 'bg_opa' + (digits ? digits[0] : '');
}

export function interpolateColor(color1, color2, ratio) {
    // console.log(color1)
    // console.log(color2)
    const hex = color => parseInt(color.substring(1), 16);
    const r = Math.floor((1 - ratio) * ((hex(color1) >> 16) & 0xff) + ratio * ((hex(color2) >> 16) & 0xff));
    const g = Math.floor((1 - ratio) * ((hex(color1) >> 8) & 0xff) + ratio * ((hex(color2) >> 8) & 0xff));
    const b = Math.floor((1 - ratio) * (hex(color1) & 0xff) + ratio * (hex(color2) & 0xff));
    return `rgb(${r}, ${g}, ${b})`;
}
